/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
import { PAMediaBatch } from "../../mediaRemoval/mediaRemoval.types";

interface Props {
    availableBatches: PAMediaBatch[];
    selectedBatch: PAMediaBatch | undefined;
    setSelectedBatch: (batch: PAMediaBatch) => void; // ✅ takes the full object
    platesCount: number;
    errors: any;
}

const PABatchSelection: React.FC<Props> = ({
    availableBatches,
    selectedBatch,
    setSelectedBatch,
    platesCount,
    errors
}) => {
    const { t } = useTranslation();

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const batch = availableBatches.find((b) => b.id === e.target.value);
        if (batch) setSelectedBatch(batch); // ✅ always sets the full object
    };

    return (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="px-8 py-2 border-b border-slate-100 bg-slate-50/50 flex items-center gap-3">
                <span className="material-symbols-outlined text-[#FF7043] text-xl mb-2">
                    inventory_2
                </span>
                <h3 className="text-xs font-black text-[#1E293B] uppercase tracking-[0.15em]">
                    {t("postAutoclaveProcess.mediaCleaning.batchSelection")}
                </h3>
            </div>
            <div className="px-8 py-2 flex items-center gap-10">
                <div className="w-full max-w-md space-y-2">
                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
                        {t("postAutoclaveProcess.mediaCleaning.selectMediaBatch")}  <span className="text-red-500">*</span>
                    </label>
                    <div className="relative group">
                        <select
                            value={selectedBatch?.id ?? ""}
                            onChange={handleChange}
                            className="w-full px-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-[12px] text-slate-700 outline-none focus:border-[#FF7043] transition-all"
                        >
                            <option value="" disabled>
                                {t("postAutoclaveProcess.mediaCleaning.selectMediaBatch")}
                            </option>

                            {availableBatches.map((batch: PAMediaBatch) => (
                                <option key={batch.id} value={batch.id}>
                                    {batch.media_batch_identifier} - ({batch.media_batch_description})
                                </option>
                            ))}
                        </select>
                        {errors.batch && (
                            <p className="mt-1 text-[11px] text-red-500">
                                {errors.batch}
                            </p>
                        )}
                    </div>
                </div>
                <div className="flex items-center gap-12 pt-6">
                    <div className="text-left border-r border-slate-100 pr-12">
                        <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                            {t("postAutoclaveProcess.mediaCleaning.activity")}
                        </p>
                        <p className="text-[13px] font-black text-[#1E293B]">
                            {t("postAutoclaveProcess.mediaCleaning.postAutoclaveWash")}
                        </p>
                    </div>
                    <div className="text-left border-r border-slate-100 pr-12">
                        <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                            {t("postAutoclaveProcess.mediaCleaning.totalPlates")}
                        </p>
                        <p className="text-[13px] font-black text-[#1E293B]">
                            {platesCount}
                        </p>
                    </div>
                    {/* <div className="text-right">
                        <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
                            {t("postAutoclaveProcess.mediaCleaning.currentAttempt")}
                        </p>
                        <p className="text-xl font-black text-red-600">
                            0 / 3
                        </p>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default PABatchSelection;
